import { mapBaggageViewModels } from "./mapBaggageViewModels";
import { mapFareViewModel } from "./mapFareViewModel";
import { mapOfferCapabilitiesViewModel } from "./mapOfferCapabilitiesViewModel";
import { mapBookingPriceViewModel } from "./mapBookingPriceViewModel";
import { mapFlightSegmentViewModels } from "./mapFlightSegmentViewModels";

/**
 * Map adapted FE offer → FlightOfferViewModel.
 * Does not expose rawDeal to UI consumers.
 *
 * @param {object|null|undefined} offer
 * @param {{
 *   pricing?: object|null,
 *   bookingExchangeRateSnapshot?: number|null,
 *   extrasSelections?: object|null,
 *   explicitNotIncludedSignal?: boolean,
 *   hasPaymentOrder?: boolean,
 * }} [ctx]
 * @returns {import("../types").FlightOfferViewModel|null}
 */
export function mapFlightOfferViewModel(offer, ctx = {}) {
  if (!offer || typeof offer !== "object") return null;
  const id = String(offer.id || offer.dealId || "").trim();
  if (!id) return null;

  const price = mapBookingPriceViewModel({
    offer,
    pricing: ctx.pricing ?? null,
    bookingExchangeRateSnapshot: ctx.bookingExchangeRateSnapshot ?? null,
  });

  return {
    id,
    routeLabel: strOrNull(offer.route) || buildRouteLabel(offer),
    segments: mapFlightSegmentViewModels(offer),
    fare: mapFareViewModel(offer),
    baggage: mapBaggageViewModels(offer, {
      explicitNotIncludedSignal: ctx.explicitNotIncludedSignal === true,
      selections: ctx.extrasSelections ?? null,
    }),
    capabilities: mapOfferCapabilitiesViewModel(offer, {
      pricing: ctx.pricing,
      hasPaymentOrder: ctx.hasPaymentOrder === true,
    }),
    price,
    airlineSummary: strOrNull(offer.airlineSummary),
    cardMeta: offer.cardMeta ? { ...offer.cardMeta } : null,
  };
}

function buildRouteLabel(offer) {
  const meta = offer?.cardMeta;
  if (meta?.originCode && meta?.destinationCode) {
    return `${meta.originCode} → ${meta.destinationCode}`;
  }
  return null;
}

function strOrNull(v) {
  if (v == null) return null;
  const s = String(v).trim();
  return s || null;
}
